import color from "color";

export const contrastsWithWhite = (color1: string) =>  color(color1).contrast(color("#fff")) >= 2.5;
